import type { Event } from "event/types/event.model";

import {
  EVENT_CONTACT_FORM_CHECKBOX_LINK,
  EVENT_CONTACT_FORM_CHECKBOX_MESSAGE,
  EVENT_CONTACT_FORM_THANKS,
  EVENT_CONTACT_FORM_VALIDATION_BUTTON,
  EVENT_CONTACT_FORM_WELCOME,
  EVENT_LANDING_MSG,
  NAV_BINGO,
  NAV_CLICK_AND_COLLECT,
  NAV_CROSSBAR,
  NAV_HTML_PAGE,
  NAV_HTML_PAGE_TWO,
  NAV_MAN_MATCH,
  NAV_PRONOS,
  NAV_PRONOSTICSV2,
  NAV_QUESTIONS,
  NAV_QUIZ,
  NAV_SELFIES_MSG,
  NAV_TITLE,
  WALL_QUESTIONS_WAITING_MESSAGE,
  WALL_WAITING_MESSAGE,
} from "_constants";
import {
  DEFAULT_GOLD_COLOR,
  DEFAULT_PLAY_BACKGROUND,
  DEFAULT_PSG_NAVIGATION_MENU_LOGO,
  DEFAULT_PSG_TEAM_LOGO,
  DEFAULT_RED_COLOR,
  DEFAULT_SCREEN_BACKGROUND,
  DEFAULT_WHITE_COLOR,
} from "../_graphic_design";

export const defaultEvent: Omit<Event, "id"> = {
  pronostics_v2_display: false,
  pronostics_v2_id: undefined,
  extra_fields: false,
  extra_fields_object: {
    email: false,
    room: false,
    enterprise: false,
    termsandconditions: false,
    location1_name: "",
    location1_enabled: false,
    location2_name: "",
    location2_enabled: false,
    location3_name: "",
    location3_enabled: false,
  } as Record<string, boolean | string>,
  goalkeepers: {
    goalkeeper1_name: "",
    goalkeeper2_name: "",
    goalkeeper1_image: "",
    goalkeeper2_image: "",
  },
  entity: "",
  colors: {
    headerBackground: DEFAULT_RED_COLOR,
    headerEventText: DEFAULT_WHITE_COLOR,
    headerEventDateText: DEFAULT_WHITE_COLOR,
    registerFormLabels: DEFAULT_WHITE_COLOR,
    registerFormSubmitButton: DEFAULT_RED_COLOR,
    registerFormSubmitButtonBorder: DEFAULT_WHITE_COLOR,
    registerFormLegalCheckBox: DEFAULT_RED_COLOR,
    registeredEventHomePageText: DEFAULT_WHITE_COLOR,
    navigationMenuBackground: DEFAULT_WHITE_COLOR,
    navigationMenuText: DEFAULT_GOLD_COLOR,
    inputBorderColor: DEFAULT_GOLD_COLOR,
  },
  images: {
    eventDesktopBackground: DEFAULT_SCREEN_BACKGROUND,
    eventMobileBackground: DEFAULT_PLAY_BACKGROUND,
    teamLogo: DEFAULT_PSG_TEAM_LOGO,
    navigationMenuLogo: DEFAULT_PSG_NAVIGATION_MENU_LOGO,
    backGroundPosition: "left",
  },
  kickoff_date: new Date().toISOString(),
  labels: {
    register_form_checkbox_link: EVENT_CONTACT_FORM_CHECKBOX_LINK,
    register_form_checkbox_msg: EVENT_CONTACT_FORM_CHECKBOX_MESSAGE,
    register_form_thanks_msg: EVENT_CONTACT_FORM_THANKS,
    register_form_validation_button: EVENT_CONTACT_FORM_VALIDATION_BUTTON,
    register_form_welcome_msg: EVENT_CONTACT_FORM_WELCOME,
    registered_welcome_msg: EVENT_LANDING_MSG,
    login_title_size: "",
  },

  header: {
    html: "",
    enabled: false,
  },
  legalUrl: "/legal.pdf",
  livelike_program: {
    leaderboard_id: null,
    program_id: null,
    widget_ids: {
      best_scorer: null,
      goals_stopped: null,
      last_scorer: null,
      match_end_score: null,
    },
  },
  navigation: {
    pronostics_v2: NAV_PRONOSTICSV2,
    html_page_two: NAV_HTML_PAGE_TWO,
    html_page: NAV_HTML_PAGE,
    bingo: NAV_BINGO,
    click_and_collect: NAV_CLICK_AND_COLLECT,
    crossbar: NAV_CROSSBAR,
    man_of_match: NAV_MAN_MATCH,
    pronostics: NAV_PRONOS,
    questions: NAV_QUESTIONS,
    quiz: NAV_QUIZ,
    selfies: NAV_SELFIES_MSG,
    title: NAV_TITLE,
    navigationType: "default",
  },
  opponent: {
    logo: "",
    name: "",
  },
  organization: "",
  pog_candidates: [null, null, null, null],
  pog_vote_ended: false,
  quiz_id: null,
  results: {
    best_scorer: null,
    best_scorer_goals: null,
    first_scorer: null,
    goals_stopped: [null, null],
    half_time_score: { own: null, opponent: null },
    last_scorer: null,
    match_end_score: { own: null, opponent: null },
  },
  footer: [],
  section: "",
  team_name: "",
  wall_id: null,
  wall_waiting_msg: WALL_WAITING_MESSAGE,
  wall_questions_waiting_msg: WALL_QUESTIONS_WAITING_MESSAGE,
  workforce_snapshot: null,
};
